
import { Component, Prop, Vue } from "vue-property-decorator";
import AsnModule from "@/store/modules/asn";
import { SystemModule } from "@/store/modules";
import { getModule } from "vuex-module-decorators";
import { RefNum } from "@/models/api/asn/refnum";
import ReferenceNumberLine from "./ReferenceNumberLine.vue";

const asnModule = getModule(AsnModule);

const systemModule = getModule(SystemModule);

interface ValueOption {
  label: string;
  value: string;
}

@Component({
    components: {
    ReferenceNumberLine
  }
})
export default class ReferenceNumberModal extends Vue {

    AllReferenceTypes: ValueOption[] = [];
    ReferenceTypes: ValueOption[] = [];

    @Prop()
    ReferenceNumbers: RefNum[];

    @Prop()
    ColumnMap: string[];

    ColumnMapFiltered: string[];

    async created(){
        this.AllReferenceTypes = systemModule.referenceTypes.map(x => ({ label: x.name, value: x.id }));
        this.ReferenceTypes = systemModule.referenceTypes.map(x => ({ label: x.name, value: x.id }));
        
        for(let i = 0; i < this.ReferenceNumbers.length; i++){
            this.ReferenceTypes =  this.ReferenceTypes.filter(x => x.label != this.ReferenceNumbers[i].referenceType.label);
        }

        this.ColumnMapFiltered = this.ColumnMap.filter(x => x !== null && x != '');
    }

    async onRefNumUpdated(refnum: RefNum){
        this.ReferenceTypes = this.AllReferenceTypes;
        for(let i = 0; i < this.ReferenceNumbers.length; i++){
            this.ReferenceTypes =  this.ReferenceTypes.filter(x => x.label != this.ReferenceNumbers[i].referenceType.label);
        }

        this.$emit('refnum-updated', refnum);
    }

    async onRefNumRemoved(refnum: RefNum){
        this.ReferenceTypes = this.AllReferenceTypes;
        for(let i = 0; i < this.ReferenceNumbers.length; i++){
            this.ReferenceTypes =  this.ReferenceTypes.filter(x => x.label != this.ReferenceNumbers[i].referenceType.label);
        }
        this.$emit('refnum-removed', refnum);
    }

    async onRefNumAdded(){
        this.$emit('refnum-added');
    }
}
